module.exports = __webpack_public_path__ + "static/media/cl.ccda3ddb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cl.gif
// module id = 26
// module chunks = 0